import "./css/style.scss";
import VideoCard from "./Components/VideoCard.jsx";
import Reveal from "./Components/Reveal.jsx";

export default function Projects({ content }) {
  return (
    <section id="projects">
      <Reveal delay={0.2}>
        <div className="section-title">Projects</div>
      </Reveal>

      <div className="projects">
        <div className="container">
          {content.map((item, i) => (
            <Reveal key={i} delay={0.4} inViewAmount={0.25}>
              <VideoCard props={item} />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
